import { render, staticRenderFns } from "./DeviceHistory.vue?vue&type=template&id=08ce43c1"
import script from "./DeviceHistory.vue?vue&type=script&lang=js"
export * from "./DeviceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports